import React from 'react';
import { Text, ScrollView, StyleSheet, View, Dimensions } from 'react-native';
import config from '../config';
import axios from 'axios';
import i18n from './../util/i18n';
import SelectDropdown from 'react-native-select-dropdown';
import { getCategories } from '../services/category.service';
import { exportGroupPerformance, exportSongPerformance, getPoints } from '../services/points.service';
import { Button, Card, FormControl, InputLabel, MenuItem, Select, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

i18n.locale = navigator.language;

class Points extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            points: [],
            songCategory: '',

            categories: [],
            category: '',
            selected_category: null,

        };
    }

    setStateAsync(state) {
        return new Promise((resolve) => {
            this.setState(state, resolve)
        });
    }

    async componentDidMount() {
        this.getPoints();
        this.setCategories();

        this.intervalID = setInterval(async () => {
            this.getPoints();
        }, 5000); // Fetches every 5 seconds
    }

    componentWillUnmount() {
        clearInterval(this.intervalID);
    }

    setCategories = async () => {
        let categories = await getCategories();
        this.setState({ categories: categories?.categories ?? [] });
    }

    getPoints = async () => {
        let query = {};
        if (this.state?.selected_category?._id) {
            query.category = this.state.selected_category._id;
        }
        let points_res = await getPoints(query);
        this.setState({ points: points_res.totalPoints });
    }


    render() {

        return (
            <ScrollView contentContainerStyle={{ flexGrow: 1, margin: 10 }}>
                <Text style={{ fontSize: 30, fontWeight: 'bold', margin: 10, textAlign: 'center' }}>{i18n.t('points')}</Text>

                <Stack direction='row' spacing={2} sx={{ mt: 2, mb: 2 }}>
                    <Button
                        variant='contained'
                        onClick={async () => {
                            let songPerformance = await exportSongPerformance();
                            // download as csv file
                            const blob = new Blob([songPerformance], { type: 'text/csv' });
                            const url = window.URL.createObjectURL(blob);
                            const a = document.createElement('a');
                            a.setAttribute('hidden', '');
                            a.setAttribute('href', url);
                            a.setAttribute('download', 'song_performance.csv');
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                        }}
                    >
                        {i18n.t('export_song_performance')}
                    </Button>
                    <Button
                        variant='outlined'
                        onClick={async () => {
                            let groupPerformance = await exportGroupPerformance();
                            // download as csv file
                            const blob = new Blob([groupPerformance], { type: 'text/csv' });
                            const url = window.URL.createObjectURL(blob);
                            const a = document.createElement('a');
                            a.setAttribute('hidden', '');
                            a.setAttribute('href', url);
                            a.setAttribute('download', 'group_performance.csv');
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                        }}
                    >
                        {i18n.t('export_group_performance')}
                    </Button>
                </Stack>


                <FormControl fullWidth size='small'>
                    <InputLabel id="category-select-label">{i18n.t('category')}</InputLabel>
                    <Select
                        size='small'
                        labelId="category-select-label"
                        id="category-select"
                        value={this.state.category}
                        label={i18n.t('category')}
                        onChange={async (e) => {
                            console.log(e.target.value);
                            await this.setStateAsync({
                                category: e.target.value,
                                selected_category: this.state.categories.find(category => category._id == e.target.value)
                            });
                            this.getPoints();
                        }}
                    >
                        <MenuItem kep='all' value=''>{i18n.t('all')}</MenuItem>
                        {this.state.categories.map((category, index) => {
                            return (
                                <MenuItem key={category._id} value={category._id}>{category.name}</MenuItem>
                            )
                        })}
                    </Select>
                </FormControl>

                <View>
                    <TableContainer component={Card} sx={{ mt: 2 }}>
                        <Table borderstyle={{ borderWidth: 2, borderColor: '#c8e1ff' }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{i18n.t('group_id')}</TableCell>
                                    <TableCell>{i18n.t('points')}</TableCell>
                                    <TableCell>{i18n.t('rank')}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(this.state.points.length > 0) ? this.state.points.map((row, index) => {
                                    return (
                                        <TableRow key={index}>
                                            <TableCell size='small'>{row.user_id}</TableCell>
                                            <TableCell size='small'>{row.points}</TableCell>
                                            <TableCell size='small'>{row.rank}</TableCell>
                                        </TableRow>
                                    )
                                }) : null}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </View>
            </ScrollView>
        );
    }

}

const styles = StyleSheet.create({
    container: { flex: 1, padding: 16, paddingTop: 30, width: Dimensions.get('window').width > 500 ? '80%' : '100%', alignSelf: 'center' },
    head: { backgroundColor: '#f1f8ff' },
    headText: { margin: 6, textAlign: 'center', fontWeight: 'bold', fontSize: 20 },
    text: { margin: 6, textAlign: 'center', fontSize: 20 }
});

export default Points;